<template>
    <div style="background-image: url('/alumBg.jpg')">
        <div class="uk-padding-large" style="background-color: rgba(251, 251, 251, 0.8)">
            <div class="uk-container">
                <div class="uk-child-width-1-2@m" uk-grid>
                    <div>
                        <dl class="uk-description-list">
                            <dt>Mission Statement</dt>
                            <dd>
                                The mission of the office of Advancement is to assist the success of Northern Caribbean University in
                                achieving her mission by securing philanthropic support of the university through individual and
                                corporate gifts, thereby nurturing the fulfilment of her role in the delivery of Christian higher
                                education.
                            </dd>

                        </dl>
                    </div>
                    <div>
                        <div>
                            <dl class="uk-description-list">
                                <dt>Vision Statement</dt>
                                <dd>
                                    To become the channel of a sustainable financial support of Northern Caribbean University, enabled
                                    by a strong network of alumni and friends who are committed to the continued delivery of quality
                                    Christ-centered education.
                                </dd>

                            </dl>
                        </div>
                        <div>
                            <dl class="uk-description-list">
                                <dt>Value Statement</dt>
                                <dd>
                                    Quality Service is not an option: It is a way of life.
                                </dd>

                            </dl>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AlumniMVV"
    }
</script>

<style scoped>
    dt{
        color: rgb(0, 78, 156);
        font-weight: bold;
        margin-bottom: 10px !important;
        font-size: large;
    }
    dd{
        color: #111 !important;
    }
    @media screen and (max-width:600px){


        dt{
            font-size: 1.1em !important;
        }

        dd{
            font-size: 0.8em !important;
        }


    }
</style>
